import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0c3d062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrap" }
const _hoisted_2 = { class: "news-wrap" }
const _hoisted_3 = { class: "news-head" }
const _hoisted_4 = { class: "base-info" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "source" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "file-wrap"
}
const _hoisted_12 = { class: "file-name" }
const _hoisted_13 = ["onClick"]

import { ref, reactive } from "vue";
import myheader from "@/components/pcComp/header1";
import footerCom from "@/components/pcComp/footerCom";
import { ElOption, ElSelect } from "element-plus";
import {
  getArticleProview,
  getColumnList,
  updateArticle
} from "../../request/api";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'proview',
  setup(__props) {

let fontSize: number = ref(null);
const value = ref("");
// 获取到当前路由的id
const router = useRouter();
let id = router.currentRoute._value.query.id;
let article = ref({});
// 获取基本数据
let getData = () => {
  getArticleProview({
    id: id
  }).then(res => {
    article.value = res.data.data;
    console.log(article.value, 323423422);
  });
};
getData();
let updateCount = () => {
  updateArticle({
    id: id
  }).then(res => {
    console.log(res);
  });
};
updateCount();

// 文字大小选择
const options = [
  {
    value: 12,
    label: "12px"
  },
  {
    value: 18,
    label: "18px"
  },
  {
    value: 22,
    label: "22px"
  },
  {
    value: 28,
    label: "28px"
  },
  {
    value: 36,
    label: "36px"
  }
];

let toPrint = () => {
  window.print();
};
let downLoad = url => {
  // list.forEach(val => {
  console.log(url, "url");
  window.open(url);
  // });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(myheader)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, "发布时间：" + _toDisplayString(_unref(article).start_time.substr(0,10)), 1),
            _createElementVNode("div", _hoisted_7, " 来源：" + _toDisplayString(_unref(article).origin.name), 1)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(ElSelect), {
              class: "select",
              modelValue: _unref(fontSize),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fontSize) ? (fontSize).value = $event : fontSize = $event)),
              placement: "top-start",
              placeholder: "字体大小",
              size: "normal"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                  return _createVNode(_unref(ElOption), {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, false]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(article).title), 1),
      _createElementVNode("div", {
        class: "content",
        style: _normalizeStyle({'font-size':_unref(fontSize)+'px'})
      }, [
        _createElementVNode("div", {
          class: "html",
          innerHTML: _unref(article).content.content
        }, null, 8, _hoisted_10)
      ], 4),
      (_unref(article).file.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(article).file, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "file-item",
                key: item.name
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1),
                _createElementVNode("div", {
                  class: "downLoad-button",
                  onClick: ($event: any) => (_unref(downLoad)(item.url))
                }, " 附件下载", 8, _hoisted_13)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "print-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toPrint) && _unref(toPrint)(...args)))
    }, "打印本页"),
    _createVNode(_unref(footerCom))
  ]))
}
}

})